// extracted by mini-css-extract-plugin
module.exports = {"image":"SecondaryProjectItem-module--image--3i0g3","root":"SecondaryProjectItem-module--root--3n43I","arrow":"SecondaryProjectItem-module--arrow--1hOO9"};